module.exports = __webpack_public_path__ + "img/5.3190a859.png";